export default "__VITE_ASSET__DoGxYsqZ__"